import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1675_194)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.93 7.248L7.46867 5.35267C7.02 5.1 6.48667 5.10467 6.04333 5.364C5.59867 5.624 5.334 6.086 5.334 6.60067V10.4C5.334 10.9147 5.59867 11.3767 6.04333 11.6367C6.27 11.7693 6.51933 11.8347 6.768 11.8347C7.00667 11.8347 7.24533 11.774 7.462 11.652L10.9367 9.74933C11.3947 9.492 11.6673 9.02533 11.6673 8.50067C11.6673 7.976 11.3947 7.50933 10.9307 7.24867L10.93 7.248ZM10.2893 8.58333L6.81467 10.4867C6.802 10.4933 6.76333 10.5147 6.71667 10.486C6.66733 10.4573 6.66733 10.4147 6.66733 10.4007V6.60133C6.66733 6.58733 6.66733 6.54467 6.71667 6.516C6.73467 6.50533 6.75133 6.502 6.766 6.502C6.79 6.502 6.80933 6.51267 6.82133 6.51933L10.2827 8.41533C10.2953 8.42267 10.3333 8.444 10.3333 8.502C10.3333 8.56 10.2947 8.58133 10.2893 8.58533V8.58333ZM8 0.5C3.58867 0.5 0 4.08867 0 8.5C0 12.9113 3.58867 16.5 8 16.5C12.4113 16.5 16 12.9113 16 8.5C16 4.08867 12.4113 0.5 8 0.5ZM8 15.1667C4.324 15.1667 1.33333 12.176 1.33333 8.5C1.33333 4.824 4.324 1.83333 8 1.83333C11.676 1.83333 14.6667 4.824 14.6667 8.5C14.6667 12.176 11.676 15.1667 8 15.1667Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1675_194",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgPlay;
